import React from 'react';
import { FaCompress, FaExpand, FaList, FaMap } from 'react-icons/fa';
import { LANDMARK_META, MAP_FIRST_USP } from '../utils/mapLandmarks';
import './MapFirstToolbar.css';

const ALL_CATEGORIES = Object.keys(LANDMARK_META).filter((k) => k !== 'property');

const MapFirstToolbar = ({
  activeCategories,
  onToggleCategory,
  onShowAllCategories,
  viewMode = 'split',
  onViewModeChange,
  isFullScreen = false,
  onToggleFullScreen,
  showViewToggle = true,
  showLandmarkFilters = true,
  compact = false,
  uspText = MAP_FIRST_USP,
}) => {
  return (
    <div className={`map-first-toolbar ${compact ? 'map-first-toolbar--compact' : ''}`}>
      {!compact && uspText && (
        <p className="map-first-usp" title={uspText}>
          <FaMap className="map-first-usp-icon" aria-hidden />
          {uspText}
        </p>
      )}

      <div className="map-first-toolbar-row">
        {showViewToggle && onViewModeChange && (
          <div className="map-view-toggle" role="group" aria-label="Results view">
            <button
              type="button"
              className={`map-view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => onViewModeChange('list')}
              aria-pressed={viewMode === 'list'}
            >
              <FaList aria-hidden />
              <span>List</span>
            </button>
            <button
              type="button"
              className={`map-view-toggle-btn ${viewMode === 'split' ? 'active' : ''}`}
              onClick={() => onViewModeChange('split')}
              aria-pressed={viewMode === 'split'}
            >
              <FaMap aria-hidden />
              <span>Split</span>
            </button>
            <button
              type="button"
              className={`map-view-toggle-btn ${viewMode === 'map' ? 'active' : ''}`}
              onClick={() => onViewModeChange('map')}
              aria-pressed={viewMode === 'map'}
            >
              <FaMap aria-hidden />
              <span>Map</span>
            </button>
          </div>
        )}

        {onToggleFullScreen && (
          <button
            type="button"
            className="map-fullscreen-btn"
            onClick={onToggleFullScreen}
            aria-label={isFullScreen ? 'Exit full screen map' : 'Full screen map'}
          >
            {isFullScreen ? <FaCompress /> : <FaExpand />}
          </button>
        )}
      </div>

      {showLandmarkFilters && onToggleCategory && onShowAllCategories && activeCategories && (
        <div className="map-landmark-filters" role="group" aria-label="Nearby landmark filters">
          <button type="button" className="map-landmark-chip map-landmark-chip--all" onClick={onShowAllCategories}>
            All
          </button>
          {ALL_CATEGORIES.map((key) => {
            const meta = LANDMARK_META[key];
            const active = activeCategories.has(key);
            return (
              <button
                key={key}
                type="button"
                className={`map-landmark-chip ${active ? 'active' : ''}`}
                style={{ '--chip-color': meta.color }}
                onClick={() => onToggleCategory(key)}
                aria-pressed={active}
              >
                <span aria-hidden>{meta.emoji}</span>
                <span>{meta.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MapFirstToolbar;
